import { render } from "./leads-details.vue?vue&type=template&id=6a11133b&scoped=true"
import script from "./leads-details.vue?vue&type=script&lang=js"
export * from "./leads-details.vue?vue&type=script&lang=js"

import "./leads-details.vue?vue&type=style&index=0&id=6a11133b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a11133b"]])

export default __exports__